import { Suspense } from 'react';
import { Loading } from 'components/Loading';
// import { ChunkErrorBoundary } from './ChunkErrorBoundary';

export const SuspenseWrapper = ({ children }) => {
  return (
    // <ChunkErrorBoundary>
    <Suspense fallback={<Loading />}>{children}</Suspense>
    // </ChunkErrorBoundary>
  );
};
